import React, { useState, useEffect } from "react";
import styled from "styled-components";

const StyledContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #007bff;
  color: #ffffff;
  padding: 25px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  z-index: 1000;
`;

const StyledText = styled.p`
  margin: 0;
  font-size: 20px;
  text-align: center;
`;

const StyledButtons = styled.div`
  display: flex;
  gap: 15px;
`;

const StyledButton = styled.button`
  background: #28a745;
  border: none;
  border-radius: 10px;
  color: #fff;
  padding: 15px 20px;
  cursor: pointer;
  font-size: 20px;
  &:hover {
    background: #218838;
  }
`;

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepté");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "refusé");
    setVisible(false);
  };

  if (!visible) return null;

  return (
      <StyledContainer>
        <StyledText>
          Nous utilisons des cookies pour améliorer votre expérience sur France Investment. Veuillez accepter leur utilisation pour garantir votre accès à des connaissances financières essentielles.
        </StyledText>
        <StyledButtons>
          <StyledButton onClick={handleAccept}>Accepter</StyledButton>
          <StyledButton onClick={handleDecline}>Refuser</StyledButton>
        </StyledButtons>
      </StyledContainer>
  );
};

export default CookieBanner;